
@if (fields$ | async; as fields) {
  @if (values && values.length > 0) {
    <div class="flex justify-start flex-wrap gap-x-3">
      @for (entry of values; track entry) {
        <div class="pill bg-extend-primary text-white">
          @if (entry.compareSymbol) {
            {{entry.uuid | selectItemText:fields}} {{entry.compareSymbol}} {{entry.value}}
          }
          @if (!entry.compareSymbol) {
            {{entry.uuid | selectItemText:fields}} = {{entry.value}}
          }
          @if (entry.include) {
            <span class="mx-1 fas fa-arrow-up text-green-300" title="Einschluss-Regel"></span>
          }
          @if (!disabled) {
            <button class="pill-button" type="button" (click)="removeEntry(entry)" title="Eintrag entfernen"><i class="fas fa-times"></i></button>
          }
        </div>
      }
    </div>
  } @else {
    <div class="no-entries-full-width justify-start p-0">Keine Werte definiert</div>
  }
}
